import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp16} 0;
`

export const SentimentRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const TopicRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const BarPlaceholder = styled.div`
  flex: 1;
`
